const BYTE_UNITS = [
    'B',
    'KB',
    'MB',
    'GB',
    'TB'
];
export const formatBytes = (value)=>{
    if (value === undefined || value === null) {
        return '-';
    }
    if (value === 0) {
        return '0 B';
    }
    const unit = Math.min(Math.floor(Math.log(value) / Math.log(1024)), BYTE_UNITS.length - 1);
    return `${(value / Math.pow(1024, unit)).toFixed(unit > 0 ? 1 : 0)} ${BYTE_UNITS[unit]}`;
};

//# sourceMappingURL=formatBytes.js.map